module.exports = __webpack_public_path__ + "img/slack-square.406c8e8f.svg";